import React from 'react';
import { PropTypes } from 'prop-types';

import { Input, Form, Checkbox } from 'antd';

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const FdsCardForm = ({
  form,
}) => (
  <Form
    name="basic"
    className="gx-form-row0"
    ref={form}
    {...formItemLayout}
  >
    <Form.Item
      name="risk_level"
      label="Risk Level"
    >
      <Input placeholder="Risk Level" />
    </Form.Item>
    <Form.Item
      label="Hard Ban"
      name="hard_ban"
      valuePropName="checked"
    >
      <Checkbox />
    </Form.Item>
    <Form.Item
      label="Fully White List Card"
      name="whitelisted"
      valuePropName="checked"
    >
      <Checkbox />
    </Form.Item>
  </Form>
);

FdsCardForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
};

FdsCardForm.defaultProps = {
  form: {},
};

export default FdsCardForm;
